
const digest = '5036ef0815c23953545b606a58afac8e680c5a462f4c50b90dac283df1a802b8';
const classes = {"wrapper":"_wrapper_36hps_1","selected":"_selected_36hps_9","avatar":"_avatar_36hps_12","text":"_text_36hps_58"};
const css = `._wrapper_36hps_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
  position: relative;
  cursor: pointer;
}
._wrapper_36hps_1._selected_36hps_9 {
  text-decoration: none;
}
._wrapper_36hps_1._selected_36hps_9 ._avatar_36hps_12 {
  height: 68px;
  width: 68px;
  position: relative;
}
._wrapper_36hps_1._selected_36hps_9 ._avatar_36hps_12 img {
  border: 4px solid #26e5ab;
}
._wrapper_36hps_1._selected_36hps_9 ._avatar_36hps_12:before {
  content: "";
  width: 24px;
  height: 24px;
  position: absolute;
  display: block;
  z-index: 3;
  right: -5px;
  bottom: -5px;
  background-image: url("/dist/patientV3/icons/check-icon-white.svg");
  background-repeat: no-repeat;
  background-position: center center;
}
._wrapper_36hps_1._selected_36hps_9 ._avatar_36hps_12:after {
  content: "";
  width: 24px;
  height: 24px;
  position: absolute;
  border-radius: 100%;
  display: block;
  z-index: 2;
  right: -5px;
  bottom: -5px;
  box-shadow: inset 0 1px 0 0 #72d3b7;
  background: #2cb488;
  background: linear-gradient(180deg, #2cb488 0, #209d92 100%);
  background-position: center;
}
._wrapper_36hps_1 ._avatar_36hps_12 {
  height: 64px;
  width: 64px;
}
._wrapper_36hps_1 ._avatar_36hps_12 img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_36hps_1 ._text_36hps_58 {
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  